(function () {
  'use strict';

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
      }).catch(function () {});
  }

  function showToast(msg) {
    var t = document.getElementById('cart-toast');
    if (!t) return;
    t.querySelector('.toast__msg').textContent = msg;
    t.hidden = false;
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.hidden = true; }, 4000);
  }

  // Product page: variants + gallery + ajax add to cart
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variant-json]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var btn = root.querySelector('[data-add-button]');
    var btnLabel = root.querySelector('[data-add-label]');
    var fieldsets = root.querySelectorAll('fieldset.option');
    var colorIndex = parseInt(root.getAttribute('data-color-index'), 10);
    if (isNaN(colorIndex)) colorIndex = -1;

    function filterByColor(color) {
      if (colorIndex < 0 || !color) return null;
      var first = null;
      root.querySelectorAll('.gallery__thumb').forEach(function (t) {
        var c = t.getAttribute('data-color');
        var show = !c || c === color;
        t.hidden = !show;
        if (show && c === color && !first) first = t.dataset.mediaId;
      });
      if (!first) {
        root.querySelectorAll('.gallery__slide').forEach(function (s) {
          if (!first && s.getAttribute('data-color') === color) first = s.dataset.mediaId;
        });
      }
      return first;
    }

    function activateMedia(id) {
      if (!id) return;
      var found = false;
      root.querySelectorAll('.gallery__slide').forEach(function (s) {
        var on = String(s.dataset.mediaId) === String(id);
        if (on) found = true;
        s.classList.toggle('is-active', on);
        var v = s.querySelector('video');
        if (v) { if (on) { v.play && v.play().catch(function(){}); } else { v.pause && v.pause(); } }
      });
      if (!found) return;
      root.querySelectorAll('.gallery__thumb').forEach(function (t) {
        t.classList.toggle('is-active', String(t.dataset.mediaId) === String(id));
      });
    }

    root.querySelectorAll('.gallery__thumb').forEach(function (t) {
      t.addEventListener('click', function () { activateMedia(t.dataset.mediaId); });
    });

    function selectedOptions() {
      var out = [];
      fieldsets.forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        out.push(c ? c.value : null);
      });
      return out;
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function render(v, updateMedia) {
      fieldsets.forEach(function (fs, i) {
        var lab = fs.querySelector('[data-option-label]');
        var c = fs.querySelector('input:checked');
        if (lab && c) lab.textContent = c.value;
      });
      if (!v) {
        if (btn) btn.disabled = true;
        if (btnLabel) btnLabel.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = v.compare
          ? '<span class="price__now">' + v.price + '</span> <s>' + v.compare + '</s>'
          : '<span class="price__now">' + v.price + '</span>';
        priceEl.classList.toggle('price--sale', !!v.compare);
      }
      if (btn) btn.disabled = !v.available;
      if (btnLabel) btnLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (updateMedia) {
        var groupFirst = filterByColor(colorIndex >= 0 ? v.options[colorIndex] : null);
        var target = v.media || groupFirst;
        if (v.media && groupFirst && colorIndex >= 0) {
          var sl = root.querySelector('.gallery__slide[data-media-id="' + v.media + '"]');
          if (sl && sl.getAttribute('data-color') && sl.getAttribute('data-color') !== v.options[colorIndex]) target = groupFirst;
        }
        if (target) activateMedia(target);
      }
      if (window.history && history.replaceState && idInput) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    // sync radios with current variant on load
    if (idInput && variants.length) {
      var cur = variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || variants[0];
      fieldsets.forEach(function (fs, i) {
        fs.querySelectorAll('input').forEach(function (inp) { inp.checked = inp.value === cur.options[i]; });
      });
      render(cur, false);
      filterByColor(colorIndex >= 0 ? cur.options[colorIndex] : null);
    }

    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', function () { render(findVariant(selectedOptions()), true); });
    });

    // quantity
    root.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(input.value, 10) || 1;
          n = b.dataset.step === 'up' ? n + 1 : Math.max(1, n - 1);
          input.value = n;
        });
      });
    });

    var form = root.querySelector('form[action*="/cart/add"]');
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btn) btn.disabled = true;
        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) { showToast(res.j.description || 'Could not add to bag'); return; }
            showToast(res.j.title + ' added to your bag');
            refreshCartCount();
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) btn.disabled = false; });
      });
    }
  });

  // Size guide link
  document.querySelectorAll('[data-open-size-guide]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var d = document.getElementById('size-guide');
      if (!d) return;
      e.preventDefault();
      d.open = true;
      d.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // Mobile menu: lock scroll while open, close on link tap / Escape
  var mnav = document.querySelector('.mobile-nav');
  if (mnav) {
    mnav.addEventListener('toggle', function () { document.documentElement.classList.toggle('nav-open', mnav.open); });
    mnav.querySelectorAll('.mobile-nav__panel a').forEach(function (a) { a.addEventListener('click', function () { mnav.open = false; }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') mnav.open = false; });
  }

  // Collection sort
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location = url.toString();
    });
  });
})();
